// extracted by mini-css-extract-plugin
export var boxItems = "_cv-1";
export var boxItemsLg = "_cv-2";
export var button = "_cv-7";
export var buttonLg = "_cv-8";
export var filterGroupBox = "_cv-0";
export var icon = "_cv-3";
export var iconSecondary = "_cv-6";
export var iconWrapper = "_cv-4";
export var iconWrapperLg = "_cv-5";